import {
  CompetitionResults,
  CreateCompetitionDto,
} from "../types/competition.types";
import { httpClient } from "./common";
import { ResponseData } from "./types";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class CompetitionsAPI {
  private static readonly API_URL = "/competitions";

  static async getCompetitionsTeamMember(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(this.API_URL, true),
      "Error al obtener la competencia"
    );
  }

  static async getCompetitions(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(this.API_URL, true),
      "Error al obtener las competencias"
    );
  }

  static async postCompetition(data: CreateCompetitionDto) {
    return withApiErrorHandling(
      () => httpClient.post(this.API_URL, data, true),
      "Error al crear la competencia"
    );
  }

  static async deleteCompetition(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.delete(`${this.API_URL}/${id}`, true),
      "Error al eliminar la competencia"
    );
  }

  static async updateCompetition(
    id: number,
    data: any
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.patch(`${this.API_URL}/${id}`, data, true),
      "Error al actualizar la competencia"
    );
  }

  static async getCompetition(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/${id}`, true),
      "Error al obtener la competencia"
    );
  }

  static async getCurrentCompetition(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/current`, true),
      "Error al obtener la competencia actual"
    );
  }

  static async getCompetitionResults(
    id: number
  ): Promise<ResponseData<CompetitionResults>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/${id}/results`, true),
      "Error al obtener los resultados de la competencia"
    );
  }

  // CR
  static async postCompetitionResult(data: {
    competition_id: number;
    team_id: number;
    final_position: number;
    total_points: number;
    total_species: number;
    total_pieces: number;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/competition-results`, data, true),
      "Error al crear el resultado de la competencia"
    );
  }

  static async deleteCompetitionResult(
    crId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.delete(`${this.API_URL}/competition-results/${crId}`, true),
      "Error al eliminar el resultado de la competencia"
    );
  }

  // BFR

  static async postBiggestFishResults(data: {
    competition_id: number;
    team_id: number;
    participant_id: number;
    fish_species_id: number;
    size_cm: number;
    points: number;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/biggest-fish-results`, data, true),
      "Error al crear el resultado de la competencia"
    );
  }

  static async deleteBiggestFishResult(
    bfrId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.delete(
          `${this.API_URL}/biggest-fish-results/${bfrId}`,
          true
        ),
      "Error al eliminar el resultado de la competencia"
    );
  }

  // TCR

  static async postTopCategoryResult(data: {
    competition_id: number;
    team_id: number;
    category_id: number;
    points: number;
    species_count: number;
    pieces_count: number;
  }): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(`${this.API_URL}/top-category-results`, data, true),
      "Error al crear el resultado de la competencia"
    );
  }

  static async deleteTopCategoryResult(
    tcrId: number
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.delete(
          `${this.API_URL}/top-category-results/${tcrId}`,
          true
        ),
      "Error al eliminar el resultado de la competencia"
    );
  }
}
